/**
 * Collection of various UI effects used across the app
 */
import $ from "jquery";

/**
 * Get cursor position in input box
 * @param {jQuery object} el
 * @returns {Number}
 */
const getCursorPosition = function(el) {
    return el.val().slice(0, el[0].selectionStart).length;
};

/**
 * Set cursor to the element
 */
const setCursorPosition = function(el, pos) {
    const func = el[0].setSelectionRange;
    
    // Some old browsers might not have setSelectionRange support.
    if (func) {
        el[0].setSelectionRange(pos, pos);
    }
};

/**
 * Fade out element, change its text and fade back in.
 * Uses jQuery's build in methods
 * @param $elt
 * @param text
 * @param {Object} [duration]
 * @param {Number} [duration.in = 300] time to fade in the text
 * @param {Number} [duration.out = 100] time to fade out the text
 * @param {Function} [callback = noop] callback to fire after text is displayed
 */
// eslint-disable-next-line unicorn/no-object-as-default-parameter
export const fadeInText = function($elt, text, duration = { out: 100, "in": 300 }, callback = () => {}) {
    // If trying to append the same text then return earlier
    if ($elt.html() === text) {
        return;
    }
    
    if (duration === false) {
        $elt.html(text);
        return;
    }
    
    $elt.fadeOut(duration.out, () => {
        $elt.html(text).fadeIn(duration.in, () => {
            callback($elt);
        });
    });
};

export const goTo = function(elt, duration) {
    const offset = Number.parseInt($("#page-content-wrapper").css("padding-top"), 10) + 50;
    $("html, body").animate({
        scrollTop: `${$(elt).offset().top - offset}px`
    }, duration || 300);
    return this;
};

/**
 * Reveal/Hide password in password-type input
 * @param {Event} e Event object
 */
export const showPassword = function(e) {
    const $target = $(e.currentTarget);
    const currentState = !!$target.data("showPassword");
    const controlsSelector = $target.data("controls");
    
    let $input = $($target.siblings("input")[0]);
    if (controlsSelector) {
        $input = $(controlsSelector);
    }
    
    if (!$input.length) {
        throw new Error("Unable to find corresponding input field");
    }
    
    // Get current cursor position
    const pos = getCursorPosition($input);
    
    if (currentState) {
        // Hide
        $input.attr("type", "password");
        $target.data("showPassword", false);
        $target.find("[data-fa-i2svg]").addClass("fa-eye").removeClass("fa-eye-slash");
    } else {
        // Show
        $input.attr("type", "text");
        $target.data("showPassword", true);
        $target.find("[data-fa-i2svg]").removeClass("fa-eye").addClass("fa-eye-slash");
    }
    
    // Set cursor back to the input
    setCursorPosition($input, pos);
    $input.focus();
    
    // Flick the bg circle
    setTimeout(() => { $target.addClass("click"); }, 0);
    setTimeout(() => { $target.removeClass("click"); }, 400);
};

export const addPlaceholderLoader = function(element) {
    if (!element) return;
    
    const width = Number.parseInt(element.dataset.loaderWidth || 100, 10);
    const height = Number.parseInt(element.dataset.loaderHeight || 15, 10);
    const isWhite = element.dataset.loaderColor === "white";
    
    element.innerHTML = `<div class='loader text-input__loading--line no-margin white-${isWhite}' style='width: ${width}px; height: ${height}px;'/>`;
};
